<template>
    <v-container fluid>
        <v-row v-if="fromBarcode">
            <v-col class="text-center" col="12">
                <v-btn depressed small :to="{ name: 'product-barcodescanner' }"
                    >scan <v-icon right dark> mdi-barcode</v-icon>
                </v-btn>
            </v-col>
        </v-row>

        <!-- Toggle vista V1/V2 -->
        <v-row v-if="product" class="mb-2">
            <v-col class="text-right" col="12">
                <v-btn
                    small
                    outlined
                    color="primary"
                    :to="{
                        name: 'product',
                        query: {
                            id: product.ar_codart,
                            fromBarcode: $route.query.fromBarcode,
                        },
                    }"
                >
                    <v-icon left small>mdi-view-dashboard</v-icon>
                    Nuova vista (V2)
                </v-btn>
            </v-col>
        </v-row>
        <v-row v-if="product">
            <v-col md="4" sm="12">
                <ProductImage
                    :product-id="product.ar_codart"
                    :height="310"
                ></ProductImage>
            </v-col>
            <v-col md="8" sm="12">
                <v-card>
                    <v-card-title class="justify-space-between">
                        <div style="line-height: 20px">
                            {{ product.ar_codart }} - {{ product.ar_descr
                            }}<br />
                            <small style="font-weight: normal"
                                >{{ product.acl_descla1 }} -&gt;
                                {{ product.acl_descla2 }}</small
                            >
                        </div>
                        <div style="font-weight: normal">
                            <small>
                                <b>H:</b> {{ product.ar_misura1 }} <b>L:</b>
                                {{ product.ar_misura2 }}<b> P:</b>
                                {{ product.ar_misura3 }}
                            </small>
                        </div>
                    </v-card-title>
                    <v-card-text>
                        <v-simple-table dense>
                            <template>
                                <tbody>
                                    <tr>
                                        <td>
                                            <span
                                                v-if="product.lc_prezzo6"
                                                class="imp"
                                                >$</span
                                            >
                                            <span v-if="product.lc_prezzo6">{{
                                                product.lc_prezzo6
                                                    | formatDollaro
                                            }}</span>
                                        </td>
                                        <td
                                            v-if="
                                                productStats &&
                                                productStats.USER.role != 'Franchise'
                                            "
                                        >
                                            <div v-if="product.lc_prezzo8">
                                                <span class="imp">Prz Li8 </span>
                                                {{
                                                    product.lc_prezzo8
                                                        | formatEuro
                                                }}
                                                <span
                                                    v-if="product.so_sconto1l8"
                                                    style="color: red"
                                                >
                                                    -
                                                    {{ product.so_sconto1l8 }}%</span
                                                >
                                                <template
                                                    v-if="product.lc_prezzonetto8"
                                                >
                                                    =
                                                    {{
                                                        product.lc_prezzonetto8
                                                            | formatEuro
                                                    }}
                                                </template>
                                            </div>
                                        </td>
                                        <td>
                                            <span
                                                v-if="product.lc_prezzo5"
                                                class="imp"
                                                >Prz Li5</span
                                            >
                                            <span v-if="product.lc_prezzo5">{{
                                                product.lc_prezzo5 | formatEuro
                                            }}</span>
                                        </td>
                                        <td>
                                            <span
                                                v-if="product.lc_prezzo1"
                                                class="imp"
                                                >Prz Ing.</span
                                            >
                                            <span v-if="product.lc_prezzo1">{{
                                                product.lc_prezzo1 | formatEuro
                                            }}</span>
                                        </td>
                                        <td>
                                            <div v-if="product.so_sconto2l3">
                                                <span class="imp"
                                                    >Prz Franch.
                                                </span>
                                                {{
                                                    product.lc_prezzo2
                                                        | formatEuro
                                                }}
                                                <span style="color: red">
                                                    -
                                                    {{
                                                        product.so_sconto2l3
                                                    }}%</span
                                                >
                                                =
                                                {{
                                                    calcoloScontoFrancising(
                                                        product
                                                    ) | formatEuro
                                                }}
                                            </div>
                                        </td>
                                        <td>
                                            <span class="imp"
                                                >Prz Ven Negozio</span
                                            >
                                            {{
                                                product.lc_prezzo2 | formatEuro
                                            }}
                                            <span style="color: red">
                                                -
                                                {{
                                                    product.so_sconto1l2
                                                }}%</span
                                            >
                                            =
                                            {{
                                                calcoloScontoNegozi(product)
                                                    | formatEuro
                                            }}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td colspan="4">
                                            <span class="imp">Fornitore </span>
                                            <router-link
                                                :to="{
                                                    name: 'product-list',
                                                    query: {
                                                        cod_supplier:
                                                            product.ar_codforn,
                                                    },
                                                }"
                                                >{{
                                                    product.ar_codforn
                                                }}</router-link
                                            >
                                            <span v-if="product.an_descr1">
                                                - {{ product.an_descr1 }}</span
                                            >
                                        </td>
                                        <td>
                                            <span class="imp">Cod.Art.F</span>
                                            {{ product.xx_codarfo }}
                                        </td>
                                    </tr>
                                </tbody>
                            </template>
                        </v-simple-table>
                        <v-divider></v-divider>
                        <v-simple-table dense>
                            <template>
                                <tbody>
                                    <tr>
                                        <td>
                                            <span class="imp">Min.Acq.</span>
                                            {{ product.ar_minordinabile }}
                                        </td>
                                        <td>
                                            <span class="imp">Inner</span>
                                            {{ product.ar_inner }}
                                        </td>
                                        <td>
                                            <span class="imp">Cart</span>
                                            {{ product.ar_cartonaggio }}
                                        </td>
                                        <td>
                                            <span
                                                v-if="product.ar_volume"
                                                class="imp"
                                                >CBM</span
                                            >
                                            <span v-if="product.ar_volume">{{
                                                product.ar_volume
                                            }}</span>
                                        </td>
                                        <td>
                                            <span
                                                v-if="product.xx_lottoriordino"
                                                class="imp"
                                                >Lotto riordino</span
                                            >
                                            <span
                                                v-if="product.xx_lottoriordino"
                                                >{{
                                                    product.xx_lottoriordino
                                                }}</span
                                            >
                                        </td>
                                    </tr>
                                </tbody>
                            </template>
                        </v-simple-table>
                        <v-divider></v-divider>
                        <v-simple-table dense>
                            <template>
                                <tbody>
                                    <tr>
                                        <td colspan="2">
                                            <span class="imp">DataCar.</span>
                                            <router-link
                                                :to="{
                                                    name: 'product-list',
                                                    query: {
                                                        cod_supplier:
                                                            product.ar_codforn,
                                                        data_carico:
                                                            product.xx_jac_primadatacm,
                                                    },
                                                }"
                                                >{{
                                                    product.xx_jac_primadatacm
                                                        | formatDada
                                                }}</router-link
                                            >
                                        </td>
                                        <td>
                                            <span class="imp">EAN</span>
                                            {{ product.bc_code }}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <span class="imp">Ubicazione</span>
                                            {{ product.ar_ubicus }}
                                        </td>
                                        <td colspan="2">
                                            <span class="imp">Stoccaggio</span>
                                            {{ product.ar_ubicst }}
                                        </td>
                                    </tr>
                                </tbody>
                            </template>
                        </v-simple-table>
                        <v-divider></v-divider>
                        <v-simple-table dense>
                            <template>
                                <tbody>
                                    <tr>
                                        <td>
                                            <div
                                                v-if="
                                                    productStats.USER.role ==
                                                    'Admin'
                                                "
                                            >
                                                <v-row
                                                    class="cont-box text-center"
                                                >
                                                    <v-col class="box"
                                                        ><span class="imp"
                                                            >C.I.</span
                                                        >
                                                        {{
                                                            productStats.SEDE
                                                                .CARICO
                                                        }}</v-col
                                                    >
                                                    <v-col class="box"
                                                        ><span>{{
                                                            (productStats.SEDE
                                                                .CARICO *
                                                                product.lc_prezzo5)
                                                                | formatEuro
                                                        }}</span></v-col
                                                    >
                                                </v-row>
                                            </div>
                                        </td>
                                        <td>
                                            <div
                                                v-if="
                                                    productStats.USER.role ==
                                                    'Admin'
                                                "
                                            >
                                                <span class="imp">C.A.</span>
                                            </div>
                                        </td>
                                        <td>
                                            <div
                                                v-if="
                                                    productStats.USER.role ==
                                                    'Admin'
                                                "
                                            >
                                                <v-row class="cont-box">
                                                    <v-col class="box">
                                                        <span class="imp"
                                                            >Sped.</span
                                                        ></v-col
                                                    >
                                                    <v-col class="box">
                                                        <span class="imp"
                                                            >Imp.</span
                                                        >
                                                    </v-col>
                                                </v-row>
                                            </div>
                                        </td>
                                        <td>
                                            <span class="imp">Stk</span>
                                            {{ product.xx_dissede }}
                                            <br />
                                            <span class="imp">Disp. netta</span>
                                            {{ product.xx_dissedeconimpegni }}
                                            <br />
                                            <span class="imp">Impegnato</span>
                                            {{ impegnatoCasaMadre(product) }}
                                        </td>
                                    </tr>
                                </tbody>
                            </template>
                        </v-simple-table>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
        <v-row v-if="productStats">
            <v-col cols="12">
                <v-card width="100%" v-if="statsFranchise.length > 0">
                    <v-card-title>FRANCHISE</v-card-title>
                    <v-card-text>
                        <v-simple-table dense>
                            <template>
                                <tbody>
                                    <tr>
                                        <th>Neg.</th>
                                        <th>Data doc.</th>
                                        <th>Car.</th>
                                        <th>Vend.</th>
                                        <th>Giac.</th>
                                        <th
                                            v-if="
                                                productStats.USER.role ==
                                                'Admin'
                                            "
                                        >
                                            Totale vendita
                                        </th>
                                        <th>% Intero</th>
                                    </tr>
                                    <tr
                                        v-for="shop in statsFranchise"
                                        :key="shop.id"
                                    >
                                        <td>{{ shop.description }}</td>
                                        <td>
                                            {{ shop.CARICO.date | formatDada }}
                                        </td>
                                        <td>
                                            {{ shop.CARICO.XX_QTACARICATA }}
                                        </td>
                                        <td>
                                            {{ shop.VENDUTO.XX_QTAVENDUTA }}
                                        </td>
                                        <td>
                                            {{ shop.GIACENZA.XX_GIACENZAFIN }}
                                        </td>
                                        <td
                                            v-if="
                                                productStats.USER.role ==
                                                'Admin'
                                            "
                                        >
                                            {{
                                                (shop.CARICO.XX_QTACARICATA *
                                                    calcoloScontoFrancising(
                                                        product
                                                    ))
                                                    | formatEuro
                                            }}
                                        </td>
                                        <td>
                                            {{
                                                calcoloPercentuale(
                                                    product,
                                                    shop.CARICO.XX_QTACARICATA
                                                ) | arrotonda(2)
                                            }}%
                                        </td>
                                    </tr>
                                    <tr class="important">
                                        <td colspan="2">TOTALE</td>
                                        <td>{{ totCarFranchise }}</td>
                                        <td>{{ totVendFranchise }}</td>
                                        <td>{{ totGiacFranchise }}</td>
                                        <td colspan="2">
                                            <span
                                                v-if="
                                                    productStats.USER.role ==
                                                    'Admin'
                                                "
                                                >{{
                                                    totVenditaEuroFranchise
                                                        | formatEuro
                                                }}</span
                                            >
                                        </td>
                                    </tr>
                                </tbody></template
                            >
                        </v-simple-table>
                    </v-card-text>
                </v-card>
            </v-col>
            <v-col cols="12">
                <v-card width="100%" v-if="statsNegozi.length > 0">
                    <v-card-title>NEGOZI</v-card-title>
                    <v-card-text>
                        <v-simple-table dense>
                            <template>
                                <tbody>
                                    <tr>
                                        <th>Neg.</th>
                                        <th>Data doc.</th>
                                        <th>Car.</th>
                                        <th>Vend.</th>
                                        <th>Giac.</th>
                                        <th
                                            v-if="
                                                productStats.USER.role ==
                                                'Admin'
                                            "
                                        >
                                            Totale vendita
                                        </th>
                                        <th>% Intero</th>
                                    </tr>
                                    <tr
                                        v-for="shop in statsNegozi"
                                        :key="shop.id"
                                    >
                                        <td>{{ shop.description }}</td>
                                        <td>
                                            {{ shop.CARICO.date | formatDada }}
                                        </td>
                                        <td>
                                            {{ shop.CARICO.XX_QTACARICATA }}
                                        </td>
                                        <td>
                                            {{ shop.VENDUTO.XX_QTAVENDUTA }}
                                        </td>
                                        <td>
                                            {{ shop.GIACENZA.XX_GIACENZAFIN }}
                                        </td>
                                        <td
                                            v-if="
                                                productStats.USER.role ==
                                                'Admin'
                                            "
                                        >
                                            {{
                                                (shop.VENDUTO.XX_QTAVENDUTA *
                                                    calcoloScontoNegozi(
                                                        product
                                                    ))
                                                    | formatEuro
                                            }}
                                        </td>
                                        <td>
                                            {{
                                                calcoloPercentuale(
                                                    product,
                                                    shop.VENDUTO.XX_QTAVENDUTA
                                                ) | arrotonda(2)
                                            }}%
                                        </td>
                                    </tr>
                                    <tr class="important">
                                        <td colspan="2">TOTALE</td>
                                        <td>{{ totCarShop }}</td>
                                        <td>{{ totVendShop }}</td>
                                        <td>{{ totGiacShop }}</td>
                                        <td colspan="2">
                                            <span
                                                v-if="
                                                    productStats.USER.role ==
                                                    'Admin'
                                                "
                                            >
                                                {{
                                                    totVenditaEuroNegozi
                                                        | formatEuro
                                                }}</span
                                            >
                                        </td>
                                    </tr>
                                </tbody></template
                            >
                        </v-simple-table>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
        <v-row v-if="productStats">
            <v-col cols="12">
                <v-card width="100%" v-if="statsFranchise.length > 0">
                    <v-card-text>
                        <v-simple-table dense>
                            <template>
                                <tbody>
                                    <tr class="important">
                                        <td><span>SUPER TOTALE</span></td>
                                        <td>
                                            Carico:
                                            {{ totCarShop + totCarFranchise }}
                                        </td>
                                        <td>
                                            Vendite:
                                            {{ totVendShop + totVendFranchise }}
                                        </td>
                                        <td>
                                            Giacenze:
                                            {{ totGiacShop + totGiacFranchise }}
                                        </td>
                                        <td
                                            v-if="
                                                productStats.USER.role ==
                                                'Admin'
                                            "
                                        >
                                            Totale:
                                            {{
                                                (totVenditaEuroNegozi +
                                                    totVenditaEuroFranchise)
                                                    | formatEuro
                                            }}
                                        </td>
                                    </tr>
                                </tbody>
                            </template>
                        </v-simple-table>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
        <v-row v-else>
            <v-col class="text-center">
                <v-progress-circular
                    indeterminate
                    color="primary"
                ></v-progress-circular>
            </v-col>
        </v-row>
    </v-container>
</template>
<style lang="scss">
.imp {
    font-weight: bold;
}
.cont-box {
    .box {
        padding: 2px;
        display: inline-block;
        border: 1px solid lightgray;
    }
}
.tr-bold {
    background: lightgray;
    td {
        font-weight: bold;
    }
}
tr {
    &.important {
        background-color: lightgray;
        font-weight: bold;
    }
}
</style>
<script>
import requests from "../requests";
import ProductImage from "./ProductImage.vue";
import Promise from "promise";

export default {
    name: "product",
    components: { ProductImage },
    computed: {
        totCar() {
            return this.calcolaSomma("carico");
        },
        totVend() {
            return this.calcolaSomma("scarico");
        },
        totGiac() {
            return this.calcolaSomma("giacenza");
        },

        totCarShop() {
            return this.calcolaSomma("carico", "shop");
        },
        totVendShop() {
            return this.calcolaSomma("scarico", "shop");
        },
        totGiacShop() {
            return this.calcolaSomma("giacenza", "shop");
        },
        totGiacShop2() {
            return this.calcolaSomma("giacenza", "shop");
        },

        totCarFranchise() {
            return this.calcolaSomma("carico", "franchise");
        },
        totVendFranchise() {
            return this.calcolaSomma("scarico", "franchise");
        },
        totGiacFranchise() {
            return this.calcolaSomma("giacenza", "franchise");
        },

        totVenditaEuroNegozi() {
            let shopsStats = _.filter(this.productStats.NEGOZI, {
                type: "shop",
            });
            let somma = 0;
            _.forEach(shopsStats, (shopStat) => {
                if (_.isNumber(shopStat.VENDUTO.XX_QTAVENDUTA))
                    somma +=
                        shopStat.VENDUTO.XX_QTAVENDUTA *
                        this.calcoloScontoNegozi(this.product);
            });
            return somma;
        },

        totVenditaEuroFranchise() {
            let shopsStats = _.filter(this.productStats.NEGOZI, {
                type: "franchise",
            });
            let somma = 0;
            _.forEach(shopsStats, (shopStat) => {
                if (_.isNumber(shopStat.CARICO.XX_QTACARICATA))
                    somma +=
                        shopStat.CARICO.XX_QTACARICATA *
                        this.calcoloScontoFrancising(this.product);
            });
            return somma;
        },

        franchisePos() {
            return _.filter(this.pointOfSales, { type: "franchise" });
        },
        standardShop() {
            return _.filter(this.pointOfSales, { type: "shop" });
        },

        statsNegozi() {
            if(this.user.role == "Solo Prodotti") return [];
            return _.filter(this.productStats.NEGOZI, { type: "shop" });
        },
        statsFranchise() {
            return _.filter(this.productStats.NEGOZI, { type: "franchise" });
        },
    },
    data: () => {
        return {
            product: null,
            productStats: null,
            fromBarcode: false,
            pointOfSales: [],
            posField: {},
            user: null
        };
    },

    mounted() {
        console.log("Product Mounted.");
        this.user = window.currentUser;
        let def0 = requests.getProduct(this.$route.query.id);
        let def1 = requests.getProductSellStats(this.$route.query.id);

        this.fromBarcode = false;
        if (
            !_.isUndefined(this.$route.query.fromBarcode) &&
            this.$route.query.fromBarcode == 1
        )
            this.fromBarcode = true;

        Promise.all([def0, def1]).then((res) => {
            this.product = res[0].data[0];
            this.productStats = res[1].data;
        });
    },

    methods: {
        calcoloScontoFrancising(product) {
            let prezzo = product.lc_prezzo2;
            let sconto1 = product.so_sconto1l3;
            let sconto2 = product.so_sconto2l3;
            let ris = prezzo - (prezzo * sconto1) / 100;
            return ris - (ris * sconto2) / 100;
        },
        calcoloScontoNegozi(product) {
            let prezzo = product.lc_prezzo2;
            let sconto1 = product.so_sconto1l2;
            return prezzo - (prezzo * sconto1) / 100;
        },
        impegnatoCasaMadre(product) {
            if (!_.isUndefined(product.xx_impegnato) && !_.isNull(product.xx_impegnato))
                return product.xx_impegnato;
            let stk = parseInt(product.xx_dissede);
            let netto = parseInt(product.xx_dissedeconimpegni);
            if (_.isNaN(stk) || _.isNaN(netto)) return 0;
            return stk - netto;
        },
        calcoloPercentuale(product, giacenza) {
            let num =
                ((giacenza * this.calcoloScontoNegozi(product)) /
                    (this.calcoloScontoNegozi(product) * this.totVend)) *
                100;
            if (_.isNaN(num)) return 0;
            return num;
        },
        calcolaSomma(type, shopType = "all") {
            let shopsStats = this.productStats.NEGOZI;
            if (shopType != "all") {
                shopsStats = _.filter(this.productStats.NEGOZI, {
                    type: shopType,
                });
            }

            let somma = 0;
            if (type == "carico") {
                _.forEach(shopsStats, (val) => {
                    if (_.isNumber(val.CARICO.XX_QTACARICATA))
                        somma += val.CARICO.XX_QTACARICATA;
                });
            }

            if (type == "scarico") {
                _.forEach(shopsStats, (val) => {
                    if (_.isNumber(val.VENDUTO.XX_QTAVENDUTA))
                        somma += val.VENDUTO.XX_QTAVENDUTA;
                });
            }

            if (type == "giacenza") {
                _.forEach(shopsStats, (val) => {
                    if (_.isNumber(val.GIACENZA.XX_GIACENZAFIN))
                        somma += val.GIACENZA.XX_GIACENZAFIN;
                });
            }
            return somma;
        },
        helperShopFields(shopId, field) {
            return this.product[this.posField[shopId][field]];
        },
    },

    filters: {
        formatEuro(number) {
            if (_.isNaN(number)) return 0;
            return new Intl.NumberFormat("it-IT", {
                style: "currency",
                currency: "EUR",
            }).format(number);
        },
        formatDollaro(number) {
            return new Intl.NumberFormat("us-US", {
                style: "currency",
                currency: "USD",
            }).format(number);
        },
        arrotonda(data, num) {
            let molt = 1;
            for (let i = 0; i < num; i++) {
                molt *= 10;
            }
            return Math.round(data * molt) / molt;
        },
        formatDada(data) {
            if (
                _.isUndefined(data) ||
                _.isNull(data) ||
                data == "1900-01-01T00:00:00"
            )
                return null;

            let dsplit = data.split("T")[0].split("-");
            let d = new Date(
                parseInt(dsplit[0]),
                parseInt(dsplit[1]) - 1,
                parseInt(dsplit[2])
            );
            return d.toLocaleString("it-IT", {
                day: "2-digit", // numeric, 2-digit
                month: "2-digit", // numeric, 2-digit, long, short, narrow
                year: "numeric", // numeric, 2-digit
            });
        },
    },
};
</script>
